import React, {useEffect, useState} from 'react';
import {
    Button,
    Typography,
    Form,
    Switch,
    Table,
    Spin,
} from "antd";
import Swal from 'sweetalert2';
import {Redirect, withRouter} from "react-router-dom";
import {Tabs} from 'antd';
import logo from '../../assets/images/logo.png'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faDownload, faSignOut} from '@fortawesome/free-solid-svg-icons';
import Pdf from "react-to-pdf";
import ConsentService from '../../API/consents/ConsentService';
import UserService from '../../API/user/UserService';
import {getLoggedInUser, setLoggedInUser} from '../../API/Cookie';
import TokenService from '../../API/token/TokenService';
import { Footer } from 'antd/lib/layout/layout';
import Footer2 from '../../components/layout/Footer2';
import Navbar from '../../components/layout/Navbar';

const {TabPane} = Tabs;
const {Title} = Typography;
const UserConsent = (props) => {
    const [isTitleLoading, setIsTitleLoading] = useState(true);
    const [platformTitle, setPlatformTitle] = useState(" ");
    const [tabsLoading, setTabsLoading] = useState(true);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [platfromTabs, setPlatfromTabs] = useState([]);
    const [consents, setConsents] = useState([]);
    const [preference, setPreference] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [consentAudits, setConsentAudits] = useState([]);
    const [redirectToSucccess, setRedirectToSucccess] = useState(false);
    const [state, setState] = useState({
        activeKey: '2'
    });
    const [toast, setToast] = useState(null);

    useEffect(() => {
        console.log(props?.user?.user?.consents);
        setConsents(props?.user?.user?.consents);
        setPreference(props?.user?.user?.preference);
        setConsentAudits(props.user?.consentAudits || []);
        const d = [];
        props?.user?.preference?.map((x, index) => {
            return d.push({
                ID: props?.user?.ID,
                name: props?.user?.firstname + " " + props.user.lastname,
                title: props?.user?.consents[index]?.title,
                status: x.status ? "opted in" : "opted out"
            })
        });
        setTableData(d);
        ConsentService.getPlatformTitle({
            id: props?.user?.company
        }, props?.user?.accessToken)
            .then((res) => {
                setIsTitleLoading(false);
                setPlatformTitle(res?.data[0]?.platformTitle);
            })
            .catch((err) => {
                setToast({
                    type: 'error',
                    title: 'Unable to load platform title',
                    message: err?.response?.data?.message || 'Something went wrong while loading the platform.'
                });
            })
        setTabsLoading(true);
        ConsentService.getPlatformTabs(props?.user?.accessToken)
            .then((res) => {
                setTabsLoading(false);
                const rvd = res.data.reverse()
                setPlatfromTabs(rvd);

            })
            .catch((err) => {
                setToast({
                    type: 'error',
                    title: 'Unable to load tabs',
                    message: err?.response?.data?.message || 'Something went wrong while loading the tabs.'
                });
            })

    }, [])

    const user = getLoggedInUser();

    const storeConsentAudit = () => {
        var dateObj = new Date();
        var month = dateObj.getUTCMonth() + 1; //months from 1-12
        var day = dateObj.getUTCDate();
        var year = dateObj.getUTCFullYear();
        const newdate = day + "/" + month + "/" + year;
        const h = (dateObj.getHours() < 10 ? '0' : '') + dateObj.getHours();
        const m = (dateObj.getMinutes() < 10 ? '0' : '') + dateObj.getMinutes();
        const time = newdate + ` ${h}:${m}`;
        const audits = [...consentAudits];
        const audit = {...preference};
        audit.lastConsentDate = time;
        audits.push(audit);
        setConsentAudits(audits);
        return audits
    }

    const handleSavePreferance = () => {
        setConfirmLoading(true);
        UserService.updateClientPreference({
            preference: [...preference],
            id: props?.user?.user?.id,
            consentAudits: storeConsentAudit()
        }, props?.user?.accessToken)
            .then((res => {
                const newUser = {...props.user,...res.data};
                const response = JSON.stringify(newUser);
                // const data = this.context.encrypt(response);
                localStorage.setItem('ClientData', response);
                setConfirmLoading(false);
                const d = [];
                preference.map((x, index) => {
                    d.push({
                        ID: props?.user?.user?.id,
                        name: props?.user?.user?.firstname + " " + props?.user?.user?.lastname,
                        title: props?.user?.user?.consents[index].title,
                        status: x.status ? "opted in" : "opted out"
                    })
                });
                setTableData(d);
                Swal.fire("Saved Successfully", "Your preference has been successfully stored", "success").then(() => {
                    setRedirectToSucccess(true);
                });
            }))
            .catch((res) => {
                setConfirmLoading(false);
                setToast({
                    type: 'error',
                    title: 'Save failed',
                    message: res?.response?.data?.message || 'Could not save consent status. Please try again.'
                });
            })
    }


    const ref = React.createRef();

    const columns = [
        {
            title: "Name",
            key: "name",
            dataIndex: "name",
        },
        {
            title: "Phone",
            dataIndex: "phone",
            key: "phone",
        },
        {
            title: "Consent",
            dataIndex: "title",
            key: "consent",
        },
        {
            title: "Status",
            key: "status",
            dataIndex: "status",
        },

    ];

    const options = {
        orientation: 'potrait',
        unit: 'in',
        format: [10.6, 15],
    };

    useEffect(() => {
        if (!toast) return;
        const timer = setTimeout(() => setToast(null), 5000);
        return () => clearTimeout(timer);
    }, [toast]);

    return (
        <>
        <div className='consent-main'>
            {
                redirectToSucccess && <Redirect to="/success" />
            }
            <div className='topbar' style={{
                zIndex: 1,width: '100%',display: 'flex',justifyContent: 'space-between',alignItems: 'center'}}>
            <Navbar />
            <br></br>
                <Button
                    // type="primary"
                    className='consent-button-signout'
                    style={{
                        width: "150px",
                        backgroundColor: 'transparent',
                        color: '#fff',
                        border: 'none',
                        backgroundImage: 'linear-gradient(-270deg, rgba(0, 150, 119, 1) 0%, rgba(80, 184, 72, 1) 100%)',
                        height: '60px',
                        borderRadius: 0,
                    }}
                    onClick={(e) => {
                        e.preventDefault();
                        setLoggedInUser();
                        localStorage.removeItem('UserData');
                        window.location.reload();
                    }}
                >
                    Sign Out
                    <span style={{marginLeft: '5px'}}>&#8594;</span>
                </Button>
            </div>

            {/* Top-right toast notification */}
            {toast && (
                <div className="toast-notification-wrapper">
                    <div className={`toast-notification ${toast.type || 'error'}`}>
                        <div>
                            {toast.title && (
                                <div className="toast-notification-title">{toast.title}</div>
                            )}
                            <div>{toast.message}</div>
                        </div>
                        <button
                            type="button"
                            className="toast-notification-close"
                            onClick={() => setToast(null)}
                        >
                            ×
                        </button>
                    </div>
                </div>
            )}

            <div className='consent-selector'>
                <Spin
                    spinning={isTitleLoading}
                >
                    <h1 >
                        {platformTitle}
                    </h1>
                </Spin>

            </div>

            <div className="consent-container">
                <Spin
                    spinning={tabsLoading}
                >

                    <Tabs
                        defaultActiveKey="1"
                        // activeKey={state.activeKey}
                        onChange={(e) => {
                            setState({...state, activeKey: e})
                        }}
                        centered
                        style={{zIndex: -1}}>
                        {
                            platfromTabs.map((x, index) => {
                                if (x.tabTitle === "Information") {
                                    return <TabPane
                                        tab={x?.userGivenTitle !== "" ? x.userGivenTitle : "Information"} key={index} style={{padding: 20, marginBottom: 50}}>
                                        <div className='content' style={{display: 'flex'}}>
                                            <div style={{margin: 'auto'}}>
                                                <h1 style={{marginTop: '50px', fontWeight: '400', color: '#000'}}>Background</h1>
                                                <p style={{marginTop: '20px', color: 'black', fontSize: '16px'}}>The Old Mutual Privacy Policy and the Cyber & Data Protection Act [Chapter 12:07] require that we obtain consent from you, our customers when using your personal information for any purpose other than that which it was collected for.</p>
                                                <p style={{marginTop: '20px', color: 'black', fontSize: '16px'}}>This platform will allow you to consent to the use of your data within and across Old Mutual and any of its Group companies (Central Africa Building Society, Old Mutual Life Assurance Company Zimbabwe Limited, Old Mutual Insurance Company Private Limited, Old Mutual Investments Group Zimbabwe Private limited, Old Mutual Finance Private Limited, Old Mutual Securities Private Limited, Old Mutual Funeral Services Private Limited, Old Mutual Zimbabwe Limited, Old Mutual Digital Services and Old Mutual Limited) and with Old Mutual agents and contractors where necessary for the reasons stated in this consent platform.</p>
                                                <h1 style={{marginTop: '15px', fontWeight: '400', color: '#000'}}>Your Consent Will Allow Old Mutual To</h1>
                                                <ul style={{marginTop: '20px', color: 'black', fontSize: '16px'}}>
                                                    <li>Better understand your needs and expectations, making it easier to tailor our products and services to meet, manage and exceed your expectations.</li>
                                                    <li>Improve our service delivery channels – both online and offline - in meeting your unique financial needs.</li>
                                                    <li>Personalise your experience with our brand and products, ensuring that the experience you have is unique and suited to you.</li>
                                                    <li>Increase our ability to engage and communicate with you for updates, opportunities, promotional offers.</li>
                                                </ul>

                                                <h1 style={{marginTop: '20px', fontWeight: '400', color: '#000'}}>Information Security</h1>
                                                <p style={{marginTop: '10px', color: 'black', fontSize: '16px'}}>Old Mutual is legally obliged to provide adequate protection for the personal information it collects and prevent unauthorised access and use of personal information. Old Mutual will, on an ongoing basis, continue to review security controls and related processes to ensure that customer’s personal information is secure.</p>

                                                <p style={{marginTop: '20px', color: 'black', fontSize: '16px'}}>Should you have given your consent to the processing of your personal data for the reasons outlined above, you can withdraw it at any time. In these cases, or if you have any other questions or wishes regarding your personal data, please send an email to <a href="mailto:datacontroller@om.co.zw">datacontroller@om.co.zw.</a> Old Mutual treats customer’s personal information with utmost care and will only process it for the purposes that it was requested for, for further details on this, please read our <a href="https://www.oldmutual.co.zw/about-us/privacy-policy/" target="_blank">Old Mutual Privacy Statement.</a></p>

                                                <h1 style={{marginTop: '20px', fontWeight: '700', fontSize: '16px', marginBottom: 50}}>NOTE: You can change your consent using this platform at any time.</h1>
                                            </div>
                                        </div>
                                    </TabPane>
                                }
                                if (x.tabTitle === "Preference") {
                                    return <TabPane tab={x?.userGivenTitle !== "" ? x.userGivenTitle : "Preference Manager"} key={index} style={{padding: 20}}>

                                        <Title className="font-regular text-muted" level={5} style={{fontSize: 12}}>
                                            {x?.shouldShowHeading && x?.preferenceHeading}
                                        </Title>
                                        {consents?.map((x, index) => {
                                            return <section key={index}>
                                                <section className="consent-item">
                                                    <Title style={{fontSize: '15px'}}>{x.title}</Title>
                                                    <Switch
                                                        checked={preference[index].status}
                                                        onChange={(e) => {
                                                            const d = [...preference];
                                                            const ob = d[index];
                                                            ob.status = e;
                                                            d.splice(index, 1, ob);
                                                            setPreference(d);
                                                        }} />
                                                </section>
                                                <p>
                                                    {x.consent}
                                                </p>
                                            </section>
                                        })}
                                        <Form.Item>
                                            <Button
                                                type="primary"
                                                className='consent-button'
                                                style={{width: "100%"}}
                                                onClick={() => handleSavePreferance()}
                                                disabled={props.user.preference === preference}
                                                loading={confirmLoading}
                                            >
                                                Save Preferance <span style={{marginLeft: '5px'}}>&#8594;</span>
                                            </Button>
                                        </Form.Item>
                                    </TabPane>
                                }
                            })
                        }
                    </Tabs>
                </Spin>

            </div>
        </div>
        <br />
        <br/>
        <Footer2 />

        </>
    )
}

export default withRouter(UserConsent)
